import moment from "moment";
import {
    dateFormatMoment
} from './../../Params.js'
import i18n from '@/plugins/i18n';


export const clearfilters = (filter, key) => {
    switch (key) {
        case 'status':
            filter.status = [];
            break;
        case 'date':
            filter.dateRange.startDate = null;
            filter.dateRange.endDate = null;
            break;
        case 'tags':
            filter.tags = [];
            break;
        case 'all':
            filter.status = [];
            filter.dateRange.startDate = null;
            filter.dateRange.endDate = null;
            break;
    }
    return filter;
}

export const showTextPicker = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
        return moment(dateRange.startDate).utc().format(dateFormatMoment()) + ' - ' + moment(dateRange.endDate).utc().format(dateFormatMoment());
    } else {
        return "<span class='date-placeholder'>" + i18n.t('Sale Contect Date') + "..." + "</span>";
    }
}


// WEBPACK FOOTER //
// ./src/components/tenancy/admin/settings/sale/sale-contact/assets/directives/Vuetable.js